import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    minHeight: theme.spacing(6),
    padding: theme.spacing(0, 2, 0, 3),
    alignItems: 'center',
    backgroundColor: theme.palette.custom.background.area,
    border: `solid ${theme.palette.divider}`,
    borderWidth: '1px 0',
    overflow: 'hidden',

    '& > .title': {
      color: theme.palette.text.secondary,
      fontWeight: theme.typography.fontWeightBold,
      flexGrow: 1,
    },
  },
}));

export default styles;
